import type { FC } from "react";
import { useSelector } from "react-redux";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { CircularLoader } from "app/components/React/CircularLoader/CircularLoader";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import {
    modalStyled,
    ModalHeading,
    ModalDetails,
    loaderStyles,
    StyledCancelButton,
} from "../shared/LoadingModal/styles";
import {
    selectCrmNameToExportContacts,
    selectCrmToExportContacts,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";

type LoadingModalProps = { isOpen: boolean; onClose(): void };

export const LoadingModal: FC<LoadingModalProps> = ({ isOpen, onClose }) => {
    const translate = useTranslation();
    const crmName = useSelector(selectCrmNameToExportContacts);
    const crm = useSelector(selectCrmToExportContacts);

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={modalStyled}
            data-automation="contacts-loading-modal"
        >
            <ModalHeading>{translate("si.advanced_search.contacts_export.matching_modal.title")}</ModalHeading>
            <ModalDetails>
                {translate(`si.advanced_search.contacts_export.matching_modal.description.${crm}`, {
                    crmName,
                })}
            </ModalDetails>

            <CircularLoader options={loaderStyles} />

            <StyledCancelButton
                type="flat"
                onClick={onClose}
                data-automation="contacts-loading-modal-cancel"
            >
                {translate("si.advanced_search.contacts_export.cancel_export")}
            </StyledCancelButton>
        </ProModal>
    );
};
